import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  updateProgress = (e) => {
    e.currentTarget.nextSibling.innerText = `${e.currentTarget.value}º`
  }
}